// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rf1rXUCADfiMq3vi1c4v {
  border: 1px solid #ddd;
  padding: 5px;
}
.rahIcsig_SfcBmWpFO8T {
  width: 100px;
  margin-left: 5px;
}
._VcIIj8P3mL8EYF9lr67 {
  width: 180px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/NozzleEdges/index.module.less"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,YAAA;AADF;AAIA;EACE,YAAA;EACA,gBAAA;AAFF;AAKA;EACE,uBAAA;AAHF","sourcesContent":["\n\n.pointEditor {\n  border: 1px solid #ddd;\n  padding: 5px;\n}\n\n.pointVal {\n  width: 100px;\n  margin-left: 5px;\n}\n\n.w200 {\n  width: 180px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pointEditor": `rf1rXUCADfiMq3vi1c4v`,
	"pointVal": `rahIcsig_SfcBmWpFO8T`,
	"w200": `_VcIIj8P3mL8EYF9lr67`
};
export default ___CSS_LOADER_EXPORT___;
